import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { StateService } from "src/app/services/state.service";
import { RestService } from "src/app/services/rest.service";
import { NzNotificationService } from "ng-zorro-antd/notification";
import { environment } from "../../../../environments/environment";

@Component({
  selector: "app-pilots",
  templateUrl: "./pilots.component.html",
  styleUrls: ["./pilots.component.css"]
})
export class PilotsComponent implements OnInit {
  addPilotisVisible = false;
  editPilotisVisible = false;
  initLoading = true; // bug
  pilotForm: FormGroup;
  strm_url = "";
  selectedPilot_id;
  // list: any[] = [];
  // list: Array<{ loading: boolean; name: any }> = [];
  constructor(
    private fb: FormBuilder,
    public _state: StateService,
    private _rest: RestService,
    private _notify: NzNotificationService
  ) {}

  ngOnInit(): void {
    this.strm_url = environment.brodcasr_url;
    this.initLoading = true;
    this.getPilots();
    this.pilotForm = this.fb.group({
      name: ["", [Validators.required]],
      area: ["", [Validators.required]]
    });
  }

  getPilots() {
    this._rest.getPilots().subscribe(
      resp => {
        this._state.pilotList = [];
        this.initLoading = false;
        this._state.pilotList = resp["RESULT"];
      },
      err => {
        this.initLoading = false;
      }
    );
  }

  addPilot(): void {
    this.addPilotisVisible = true;
  }

  addPilotSubmit() {
    console.log(this.pilotForm.valid, this.pilotForm.value);
    this._rest.addPilot(this.pilotForm.value).subscribe(resp => {
      this._notify.create("success", "Added", resp["RESULT"]);
      this.addPilotisVisible = false;
      this.getPilots();
    });
  }

  edit(item: any): void {
    console.log(item);
    this.pilotForm.patchValue({
      name: item.name,
      area: item.area
    });
    this.selectedPilot_id = item.id;
    this.editPilotisVisible = true;
  }

  updatePilotSubmit() {
    console.log(this.pilotForm.valid, this.pilotForm.value);
    this._rest
      .updatePilot(this.selectedPilot_id, this.pilotForm.value)
      .subscribe(resp => {
        this._notify.create("success", "Updated", resp["RESULT"]);
        this.editPilotisVisible = false;
        this.addPilotisVisible = false;
        this.getPilots();
      });
  }

  deletePilotSubmit(item) {
    if (confirm("Are you sure?")) {
      this._rest.deletePilot(item).subscribe(resp => {
        this._notify.create("success", "Deleted", resp["RESULT"]);
        this.editPilotisVisible = false;
        this.addPilotisVisible = false;
        this.getPilots();
      });
    }
  }
}
